/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { promises as fs } from 'fs';
import { execAsync } from './execAsync';
import { diag } from '@opentelemetry/api';

export async function getMachineId(): Promise<string | undefined> {
  try {
    const result = await fs.readFile('/etc/hostid', { encoding: 'utf8' });
    return result.trim();
  } catch (e) {
    diag.debug(`error reading machine id: ${e}`);
  }

  try {
    const result = await execAsync('kenv -q smbios.system.uuid');
    return result.stdout.trim();
  } catch (e) {
    diag.debug(`error reading machine id: ${e}`);
  }

  return undefined;
}
